import { SectionName } from './enums';

export const SECTIONS_WITH_BORDERS = [
  SectionName.Payment,
  SectionName.Shipping,
  SectionName.International,
  SectionName.Social,
];
